export interface ApiGetContentStorageRequest {
    cache_id: string;
}

export interface ApiGetContentStorageResponse {
    overrun: boolean,
    content: string
}

export const GetContentStorage = Symbol('GetContentStorage');

export interface GetContentStorage {
    getContentStorage(data: ApiGetContentStorageRequest): Promise<ApiGetContentStorageResponse>;
}
